"use client";
import { j as e } from "./index.es9.js";
import { forwardRef as n, useMemo as h } from "react";
import { makeUniqueId as m } from "./index.es88.js";
const k = n(
  ({ label: d, isChecked: i, onChange: s, isDefaultChecked: r, isDisabled: c, inputId: a, ...l }, t) => {
    const o = h(() => m(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-checkbox", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...l,
          ref: t,
          onChange: s,
          type: "checkbox",
          id: a || o,
          defaultChecked: r,
          disabled: c,
          checked: i
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: a || o, children: d })
    ] });
  }
);
export {
  k as default
};
//# sourceMappingURL=index.es10.js.map
